import Inventory2Icon from '@mui/icons-material/Inventory2';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PersonIcon from '@mui/icons-material/Person';
import TagIcon from '@mui/icons-material/Tag';
import type { ModuleInfo, NavigationItem } from '@core/router/types';
import { Permissions } from '@core/auth/permissions';

export const documentArchiveModuleInfo: ModuleInfo = {
  id: 'arhiva-dokumenata',
  labelKey: 'modules.documentArchive.name',
  icon: <Inventory2Icon />,
  basePath: '/arhiva-dokumenata',
  accessPermission: Permissions.DocumentArchive.Module.Access,
  order: 4,
};

// The catalogs follow the documents directly (one click each), separated from daily work
export const documentArchiveNavigation: NavigationItem[] = [
  {
    label: 'Dokumenti',
    labelKey: 'documentArchive.nav.documents',
    path: '/arhiva-dokumenata/dokumenti',
    icon: <DescriptionIcon />,
    permission: Permissions.DocumentArchive.Module.Access,
  },
  {
    label: 'Tipovi dokumenata',
    labelKey: 'documentArchive.nav.documentTypes',
    path: '/arhiva-dokumenata/tipovi-dokumenata',
    icon: <TagIcon />,
    permission: Permissions.DocumentArchive.Catalogs.Manage,
    dividerBefore: true,
  },
  {
    label: 'Korespondenti',
    labelKey: 'documentArchive.nav.correspondents',
    path: '/arhiva-dokumenata/korespondenti',
    icon: <PersonIcon />,
    permission: Permissions.DocumentArchive.Catalogs.Manage,
  },
  {
    label: 'Tagovi',
    labelKey: 'documentArchive.nav.tags',
    path: '/arhiva-dokumenata/tagovi',
    icon: <LocalOfferIcon />,
    permission: Permissions.DocumentArchive.Catalogs.Manage,
  },
];
